// Dependecies
import React, { useState, useEffect } from 'react';
import * as moment from 'moment';
import { useAccordionToggle } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { reject } from 'lodash';

// Store
import getMaintenanceHistory from '../../store/maintenanceHistory';
import user from '../../store/user';

// Hooks
import useLanguage from '../useLanguage';

function useMaintenanceHistory() {
  const { locale } = useLanguage();
  const [, maintenanceHistoryActions] = getMaintenanceHistory();
  const [userStore] = user();
  const [maintenanceHistorys, useSetMaintenanceHistory] = useState([]);
  const [filterDate, useSetFilterDate] = useState(false);
  const [reload, setReload] = useState(false);
  const [dataHistorys, useSetDataHistorys] = useState(false);
  const [openModalImage, setopenModalImage] = useState(false);
  const [urlImageService, setUrlImageService] = useState('');
  // change page

  const [dateInitial, useSetDateInitial] = useState(moment().subtract(1, 'years'));
  const [dateFinal, useSetDateFinal] = useState(moment());

  const [currentPage, setCurrentPage] = useState(1);
  const [cardPerPage] = useState(6);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(cardPerPage);
  const handleChange = (page) => {
    setCurrentPage(page);
    setMinIndex((page - 1) * cardPerPage);
    setMaxIndex(page * cardPerPage);
  };

  useEffect(() => {
    if (userStore.token) {
      const dataFilter = {
        dateInitial: `${moment(dateInitial).format('YYYY-MM-DD')} 00:00:00`,
        dateFinal: `${moment(dateFinal).format('YYYY-MM-DD')} 23:00:00`,
      };
      maintenanceHistoryActions.getMaintenanceHistory(dataFilter, userStore.token, locale).then(
        (response) => {
          useSetMaintenanceHistory(response.history);
          useSetFilterDate(false);
          if (response.history.length > 0) {
            useSetDataHistorys(true);
          }
          setReload(true);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
    }
  }, [userStore.token, filterDate]);

  function CustomToggle({ children, eventKey, handleClick }) {
    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      handleClick();
    });

    return (
      <div className="arrow-card" onClick={decoratedOnClick}>
        {children}
      </div>
    );
  }
  CustomToggle.propTypes = {
    children: PropTypes.node.isRequired,
    eventKey: PropTypes.number.isRequired,
    handleClick: PropTypes.func.isRequired,
  };

  function onChangeInitial(date) {
    useSetDateInitial(date);
  }
  function onChangeFinal(date) {
    useSetDateFinal(date);
  }

  function newFilter() {
    useSetDateInitial(moment().subtract(1, 'years'));
    useSetDateFinal(moment());
    useSetFilterDate(true);
  }
  function setUrlImageServices(img) {
    setUrlImageService(img);
    setopenModalImage(true);
  }

  return {
    maintenanceHistorys,
    dateInitial,
    dateFinal,
    useSetDateInitial,
    useSetDateFinal,
    useSetFilterDate,
    onChangeInitial,
    onChangeFinal,
    currentPage,
    cardPerPage,
    handleChange,
    minIndex,
    maxIndex,
    reload,
    dataHistorys,
    CustomToggle,
    newFilter,
    setUrlImageServices,
    urlImageService,
    openModalImage,
  };
}

export default useMaintenanceHistory;
